  <!-- =======================new-hone-page==================================== -->
  <div style="display: inline;">
    <div class="page-layout blank fullwidth" 
      style="overflow-y: auto;height: 1px;
      background: linear-gradient(to right, #FEF7FF, #FFFFFF, #F0F9FF);">
      <!-- ===== CREATE REQUEST SECTION ===== -->
      <div class="asp-home-new">
        <!-- Background bubbles -->
        <!-- <div class="asp-home-new__bg">
          <div class="asp-home-new__circle asp-home-new__circle--one"></div>
          <div class="asp-home-new__circle asp-home-new__circle--two"></div>
          <div class="asp-home-new__circle asp-home-new__circle--three"></div>
        </div>
        <div class="asp-home-new__content">
          <div class="asp-home-new__card">
            <h1 class="asp-home-new__title">✨ Create Request</h1>
            <p class="asp-home-new__subtitle">
              Got a car waiting? Don’t worry — tell us what you need and we will take care of it.
            </p>
            
            <button class="asp-home-new__button" (click)="loadrequest()">🚗 Create New Request ➜</button>
            <ng-template #requestorder></ng-template>
            
          
            <p class="asp-home-new__footer">Create a Request — we’ll handle the rest..</p>

            <div class="asp-home-new__tags">
              <span class="asp-home-new__tag asp-home-new__tag--blue">⏱️ Priority handling</span>
              <span class="asp-home-new__tag asp-home-new__tag--green">🔒 Secure</span>
              <span class="asp-home-new__tag asp-home-new__tag--pink">🎯 Accurate</span>
            </div>
          </div>
        </div> -->
        <!-- ===== FLOATING BUTTON ===== -->
        <div   class="floating-request-btn"
          id="floatingBtn"
          [class.always-visible]="ismobile">
          <div class="floating-request-btn__icon">
            <div class="sparkle sparkle--1">✨</div>
            <div>🛠️</div>
            <div class="sparkle sparkle--2">⚡</div>
          </div>

          <div class="floating-request-btn__text" (click)="loadrequest()">
            <div class="title-with-dots" >
              <strong>Create Request</strong>
              <div class="rotating-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
            <div class="green-title-with-dots">
              <span>Fast & Reliable</span>
              <div class="rotating-dots-green">
                  <span></span><span></span><span></span>
              </div>
            </div>
          </div>

          <span class="floating-request-btn__badge">NEW</span>
        </div>
        <!-- ===== DASHBOARD SECTION BELOW ===== -->
        <div class="asp-dashboard" *ngIf="hasDashboardData">

          <!-- Greeting -->
          <div class="asp-dashboard__greeting">
            <div class="left">
              <strong>{{ greeting }}, {{spareSelectedGarageName}} 👋</strong>
            </div>
            <div class="right">
              <button class="asp-home-new-button" (click)="loadrequest()">🚗 Create New Request ➜</button>
              <ng-template #requestorder></ng-template>
              <span class="bell">🔔</span>
            </div>
          </div>
          <!-- Greeting -->

          <!-- Quick Actions -->
          <div class="asp-dashboard__actions" *ngIf="hasDashboardData">
            <button  (click)="loadOrderList()">
              <div class="track-btn">📦</div>
              <div class="track-btn-txt">Track Orders</div>
            </button>
            <button  (click)="loadMakePayment()">
              <div class="pay-btn">💳</div>
              <div class="pay-bt-txt">Make Payment</div>  
            </button>
          </div>
          <!-- Today's To-Do -->
          <div class="asp-dashboard__todo" *ngIf="pendingCount > 0 || totalDues > 0">
            <div class="asp-dashboard__todo-header"  *ngIf="pendingCount > 0 || totalDues > 0">
              <h3><span class="todo-icon" style="color:#4a3500 ;">📋</span> Today's To-Do</h3>
              <span class="pending"  *ngIf="pendingCount > 0">• {{ pendingCount }} pending</span>
            </div>

            <div class="asp-dashboard__todo-item" *ngIf="pendingCount > 0">
              <p>🧾 Quotes awaiting approval: <strong>{{ pendingCount }}</strong></p>
              <!-- <button class="review-btn">Review</button> -->
              <button class="review-btn" (click)="goToRequestsByStatus(8)"> Review</button>

            </div>

            <div class="asp-dashboard__todo-item" *ngIf="totalDues > 0">
              <div class="another-p">💰 Total Dues: <strong>₹{{ totalDues | number:'1.2-2' }}</strong></div>
              <!-- <span>• Next due: <strong>Dec 28</strong></span> -->
              <button class="paynow-btn"  (click)="loadMakePayment()">Pay Now</button>
            </div>
          </div>

          <!-- Monthly Snapshot -->
          <div class="asp-dashboard__snapshot" *ngIf="  totalSavings > 0 ||  totalPurchase > 0 || totalOrders > 0 ||   oesPercentage > 0 ">
            <h3>📊 Monthly Snapshot • {{month}}</h3>

            <div class="asp-dashboard__grid">
              <div class="card" *ngIf="totalSavings > 0">
                <p>🎉 Savings</p>
                <h4>{{ totalSavings | number:'1.2-2' }}</h4>
                <!-- <span class="growth">⬆ {{totalSavingsPercentage}}% vs last month</span> -->
              </div>

              <div class="card" *ngIf="totalPurchase > 0">
                <p>💸 Total Purchase</p>
                <h4>₹{{ totalPurchase | number:'1.2-2' }}</h4>
                <!-- <span class="growth">⬆ {{totalPurchasePercentage}}% vs last month</span> -->
              </div>

              <div class="card small"  *ngIf="totalOrders > 0">
                <p>📦 Orders</p>
                <h4>{{ totalOrders }}</h4>
              </div>

              <div class="card small" *ngIf="oesPercentage > 0">
                <p>⚙️ OES Share</p>
                <h4>{{ oesPercentage }}%</h4>
              </div>
            </div>
          </div>

          <!-- Recent Orders -->
          <div class="asp-dashboard__orders"  *ngIf="recentOrdersList?.length > 0">
            <h3>🚛 Recent Orders</h3>

            <div class="order-card" *ngFor="let order of recentOrdersList">
              <div><strong>ORD- {{ order.orderNumber }} • {{ order.registrationNumber }} • ₹{{ order.totalAmount }}</strong>
                <p *ngIf="order.orderStatus && order.orderStatus !== 'draft'">  {{ getOrderStatusText(order.orderStatus) }} 
                  <span *ngIf="order.createdAt"> • ETA: {{ order.createdAt | date:'MMM d' }}</span>
                </p>
              </div>
              <div class="order-footer" *ngIf="order.orderStatus && order.orderStatus !== 'draft'">
                <span class="status-order" [ngClass]="getOrderStatusClass(order.orderStatus)"> {{ getOrderStatusIcon(order.orderStatus) }} {{ order.orderStatus | titlecase }}</span>
                <!-- <button>Track ➜</button> -->
                <button (click)="loadorderdetails(order.orderKey)">Track ➜</button>
              </div>
            </div>
          </div>

          <!-- Requests in Progress -->
          <div class="asp-dashboard__requests"  *ngIf="requestProgressList?.length > 0">
            <h3>⚡ Requests in Progress</h3>

            <div class="request-card" *ngFor="let req of requestProgressList">
              <div><strong>REQ-{{ req.requestId }} • {{ formatItemNames(req.itemNames) }}</strong>
              <!-- <p> {{ getStatusMessage(buildStatusDetails(req.status)) }}</p> </div> -->
              <p>{{ getRequestStatusText(req.status) }}</p>
              <div class="request-footer">
                <span class="status" [ngClass]="getStatusClass(req.status)"> {{ getStatusMessage(buildStatusDetails(req.status)) }}</span>
                <!-- <button>Open ➜</button> -->
                <button (click)="navigateToDetails(req.requestId)">Open ➜</button>
              </div>
            </div>
          </div>
          <!-- Recent Activity -->
          <!-- <div class="asp-dashboard__activity">
            <h3>📈 Recent Activity</h3>
            <div class="recent-activity">
              <div class="activity-item">
                <span class="icon">✅</span>
                <div class="info">
                  <strong>Quote approved for REQ-2024-046</strong>
                  <p>Headlight assembly • ₹4,200</p>
                  <small>5 min ago</small>
                </div>
              </div>

              <div class="activity-item">
                <span class="icon">📦</span>
                <div class="info">
                  <strong>Order ORD-2024-001 delivered</strong>
                  <p>MH12AB1234 • Brake pads</p>
                  <small>1 hour ago</small>
                </div>
              </div>

              <div class="activity-item">
                <span class="icon">💰</span>
                <div class="info">
                  <strong>Payment received</strong>
                  <p>₹12,500 for ORD-2024-001</p>
                  <small>2 hours ago</small>
                </div>
              </div>

              <div class="activity-item">
                <span class="icon">📄</span>
                <div class="info">
                  <strong>New quote request submitted</strong>
                  <p>REQ-2024-047 • Engine oil change</p>
                  <small>3 hours ago</small>
                </div>
              </div>

              <div class="activity-item">
                <span class="icon">🚚</span>
                <div class="info">
                  <strong>Order shipped</strong>
                  <p>ORD-2024-002 • ETA: Dec 27</p>
                  <small>4 hours ago</small>
                </div>
              </div>
            </div>
          </div> -->
          <div class="activity-footer"   *ngIf="totalSavings > 0">
              💡 Great going! You’ve saved <strong>₹{{ totalSavings | number:'1.2-2' }}</strong> this month with <strong>Autoverse</strong>.
          </div>
        </div>

        </div>
      <ng-template #orderlistContainer></ng-template>
    <!-- =======================new-hone-page-end==================================== -->
    <!-- <div class="page-layout blank fullwidth"  style="height: 1px; overflow-y: scroll;    top: 1px;z-index: 99999;"> -->

            <div  [attr.id]="isMobile ? 'vehicleMobile' : 'vehicle'" class="inner-scroll" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="center" >
                <div class="SearchBarContainer" (click)="toggleSearch()" [ngClass]="{'SearchBarContainerMobile': isMobile}" *ngIf="isMobile">
                    <div class="SearchBarButton">
                      <div class="SearchBarIcon">
                        <i class="material-icons">search</i>
                      </div>
                      <div class="SearchBarPlaceholder">
                        <div class="SearchBarAnimation" *ngIf="!isInputVisible">
                          <div id="animationText-1" class="SearchBarAnimationText">Search By "Part Name"</div>
                          <div id="animationText-2" class="SearchBarAnimationText">Search By "Part Number"</div>
                          <div id="animationText-3" class="SearchBarAnimationText">Search By "Brand"</div>
                          <div id="animationText-4" class="SearchBarAnimationText">Search By "Category"</div>
                        </div>
                  
                        <div *ngIf="isInputVisible" class="SearchInputContainer" (click)="$event.stopPropagation()">
                            <input
                              type="text"
                              placeholder="Type your search"
                              class="SearchInput"
                              [(ngModel)]="searchText"
                              (input)="filterSuggestions()"
                              (click)="toggleSearch()"
                            >
                            <button (click)="clearSearch($event)" class="button">
                              <i class="material-icons" style="font-size: 16px;">clear</i>
                            </button>
                    
                            <!-- Suggestions Dropdown -->
                            <div #dropdown class="suggestions" *ngIf="suggestions.length > 0">
                              <div *ngFor="let suggestion of suggestions; let i = index" (click)="selectSuggestion(suggestion)">
                                <i class="material-icons" *ngIf="isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">access_time</i>
                                <i class="material-icons" *ngIf="!isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">search</i>
                                <span [innerHTML]="getHighlightedText(suggestion.value, searchText)"></span>

                              </div>
                            </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
            
            <div id="vehicle-intro" fxFlex>
                
                <div class="title" [@animate]="{value:'*',params:{delay:'650ms',y:'25px'}}" [ngClass]="{'titleMobile': isMobile}">
                    Welcome to  The <strong>  Universe of Auto Parts</strong>
                </div>
                <div class="description" [@animate]="{value:'*',params:{delay:'700ms',y:'25px'}}">
                    
                    <strong>Timely delivery of genuine spare parts, every time!</strong>
                </div>
            </div>
<div id="vehicle-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}" [ngClass]="{'is-make': !vehicleInfo}">
            <div id="vehicle-form" *ngIf="!vehicleInfo" style="margin-top: 2%;width: 100%;">
                <form [class.loading]="loading" name="vehicleForm" [formGroup]="vehicleForm" (ngSubmit)="onSubmit()" novalidate>
                    <div class="enter">
                        <mat-label for="regNo">Enter your car number</mat-label>
                    </div>

<!-- Google Analytics -->
<!-- <button (click)="onButtonClick()">Click Me</button> -->
<!-- End Google Analytics -->


                    <mat-form-field appearance="outline" style="font-size: larger;">
                        <div style="display: flex; align-items: center;">
                            <div class="left-section"  >
                                <img src="../../../../assets/images/home-page-reg-number/Group 16(1).png" alt="Car" width="18" height="10">
                                <span class="ind" >IND</span>
                            </div>
                            <div style="border-right: 1px solid #dddddd;height: 20px;width: 2px;    margin-top: 4px;"></div>
                            <div class="registration-number">
                                <input id="regNo" matInput formControlName="regNo" autocomplete="off" placeholder="KA 01 MY97**" maxlength="13" style="font-weight: 600; width: 98%;">
                            </div>
                            
                        </div>
                        <mat-error *ngIf="vehicleForm.get('regNo').hasError('required')">
                            Registration Number is required
                        </mat-error>
                    </mat-form-field>
                    <button mat-raised-button color="accent" class="submit-button" aria-label="VEHICLE" [disabled]="vehicleForm.invalid">
                        FIND MY CAR
                    </button>
                </form>

                <div class="separator" [ngClass]="{'separatorMobile': isMobile}">
                    <span class="text">Or</span>
                </div>

                <h4 class="text-center" [ngClass]="{'text-centerMobile': isMobile}" (click)="goToMake()">Enter car details manually</h4>
                <div *ngIf="isOpenMake">
                    <div [ngClass]="{'popularMMobile': isMobile}">
                    <div class="popularMakes" *ngFor="let make of makeList" (click)="selectMake(make.make)">
                        <img class="img-fluid make-image" src="{{make.imageUrlPath}}" alt="" />
                    </div>
                </div >
                    <div class="popularMakes viewAll" style="padding: 24px 10px;" (click)="goToMake()">
                        View All
                    </div>
                </div>
                <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
            </div>

            <div [attr.id]="isMobile ? 'vehicle-infoMobile' : 'vehicle-info'" *ngIf="vehicleInfo"  #popupSection>
                <!-- <mat-icon class="car-icon">directions_car</mat-icon> -->
                <div class="logo-container">
                    <img src="../../../../assets/images/logos/mobile_autoverse_logo.svg" alt="Autoverse Logo">
                    <p><strong>AUTOVERSE</strong></p>
                    <img src="../../../../assets/images/share.png" alt="Share" (click)="shareDetails()" style="left: 28%;position: relative; cursor: pointer;">
                </div>
                <p class="registration-number">{{vehicleData.registrationNumber}}</p>
                <!-- <h3>Confirm your car details</h3> -->
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Make</div>
                    <div class="right">{{vehicleData.make}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Model</div>
                    <div class="right">{{vehicleData.model}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Variant</div>
                    <div class="right">{{vehicleData.variant}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>MFG Year</div>
                    <div class="right">{{vehicleData.year}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Fuel</div>
                    <div class="right">{{vehicleData.fuel}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>VIN</div>
                    <div class="right">{{vehicleData.vin}}</div>
                </div>
                  <div class="vehicle-details-row" *ngIf="vehicleData?.generation">
                    <div class="left"><mat-icon>check_circle</mat-icon>Generation</div>
                    <div class="right">{{vehicleData.generation}}</div>
                </div>
                  <div class="vehicle-details-row" *ngIf="vehicleData?.vehicleType">
                    <div class="left"><mat-icon>check_circle</mat-icon>Vehicle Type</div>
                    <div class="right">{{vehicleData.vehicleType}}</div>
                </div>


                <button mat-raised-button color="accent" class="confirm-btn" aria-label="Confirm" (click)="confirmCar()">
                    Confirm
                </button>
                <button mat-raised-button color="accent" class="change-car-button" aria-label="Change Car" (click)="changeCar()">
                    Change Car
                </button>
            </div>
        </div>
        </div>
        <div class="banners-container" (pointerdown)="stopAutoScroll()">
            <mat-icon class="scroll-button left" (click)="scrollLeft()">keyboard_arrow_left</mat-icon>
            <!-- <button >&lt;</button> -->
            <div class="banners">

                <img class="bumper-banner" (click)="categoryBanner()" src="../../../../assets/images/banners/Bumper.jpg">
                <img class="bumper-banner" (click)="Head_Lamp_1()" src="../../../../assets/images/banners/Head_Lamp_1.jpg">
                <img class="bumper-banner" (click)="brandBanner()" src="../../../../assets/images/banners/Bosch_Wiper_Blades 1.jpg">
                <img class="bumper-banner" (click)="Purolator_Filters()" src="../../../../assets/images/banners/Purolator_Filters_2.jpg">
                <img class="bumper-banner" (click)="Floron_AC_Gas()" src="../../../../assets/images/banners/Floron_AC_Gas.jpg">
                <img class="bumper-banner" (click)="Hella_Coolant_Premium1()" src="../../../../assets/images/banners/Hella_Coolant_Premium1.jpg"> 
                <img class="bumper-banner" (click)="Maruti_Suzuki_Clutch_Release()" src="../../../../assets/images/banners/Maruti_Suzuki's_Clutch_Release_Bearing_2.jpg">
                <img class="bumper-banner" (click)="NGK_Spark_Plugs_1()" src="../../../../assets/images/banners/NGK_Spark_Plugs_1.jpg">
                <img class="bumper-banner" (click)="TVS_Girling_Brake_Pads_1()" src="../../../../assets/images/banners/TVS_Girling_Brake_Pads_1.jpg">
                <img class="bumper-banner" (click)="Zip_AC_Filters()" src="../../../../assets/images/banners/Zip_AC_Filters!.jpg">
                
            </div>
            <mat-icon class="scroll-button right" (click)="scrollRight()">keyboard_arrow_right</mat-icon>
            <!-- <button >&gt;</button> -->
    </div>
        <mat-card class="mat-elevation-z8 mt-8 p-8 home p-12"  >
            <mat-card-header>
                <mat-card-title  >Shop By Categories</mat-card-title>
            </mat-card-header>

            <mat-card-content>
                <div *ngIf="veiwMoreCat" fxLayout="column" fxLayout.xs="column" style="padding: 10px;">
                    <div fxLayout="row wrap" fxLayoutGap="10px">
                        <div *ngFor="let cat of categories; let i = index" fxFlex="23.7%" [ngClass]="{'CategoriesInsideMobile': isMobile}">
                            <mat-card *ngIf="i <= 7" (click)="sparesList(cat.name, 'categorySpares')">
                                <img src="{{cat.imageUrl}}"  [ngClass]="{'CategoriesImgMobile': isMobile}" alt="">
                                <div class="cat_name"  [ngClass]="{'cat_nameMobile': isMobile}">{{cat.name}}</div>
                            </mat-card>
                        </div>
                    </div>
                    <button mat-button (click)="getAllCategories()" class="view-more-cat" [ngClass]="{'view-more-catMobile': isMobile}">View More</button>
                </div>
                

                <div *ngIf="veiwLessCat" fxLayout="column" fxLayout.xs="column" style="padding: 10px;">
                    <div fxLayout="row wrap" fxLayoutGap="10px">
                        <div *ngFor="let cat of allCategories; let i = index" fxFlex="23.7%" [ngClass]="{'CategoriesInsideMobile': isMobile}">
                            <mat-card (click)="sparesList(cat.name, 'categorySpares')">
                                <img src="{{cat.imageUrl}}" [ngClass]="{'CategoriesImgMobile': isMobile}" alt="">
                                <div class="cat_name" [ngClass]="{'cat_nameMobile': isMobile}">{{cat.name}}</div>
                            </mat-card>
                        </div>
                    </div>
                    <button mat-button (click)="viewLessBrands()" class="view-less-cat" [ngClass]="{'view-less-catMobile': isMobile}">View Less</button>
                </div>
            </mat-card-content>
        </mat-card>
        <!-- <img class="banner-img" (click)="loadorderdetails()" src="../../../../assets/images/banner_spare-kit.jpg"> -->

        <mat-card class="mat-elevation-z8 mt-8 p-8 home p-12" >
            <mat-card-header>
                <mat-card-title >Popular Brands</mat-card-title>
                <span class="view-all-brands" (click)="goToAllBrands()">View All</span>
            </mat-card-header>

            <mat-card-content>
                <div fxLayout="column" fxLayout.xs="column" style="padding: 10px;">
                    <div fxLayout="row wrap" fxLayoutGap="10px">
                        <div *ngFor="let brand of brands; let i = index" fxFlex="23.7%" [ngClass]="{'CategoriesInsideMobile': isMobile}">                        
                            <mat-card *ngIf="i<=7" (click)="sparesList(brand.name, 'brandSpares', brand.imageUrl,brand.key)">
                                <img src="{{brand.imageUrl}}" [ngClass]="{'CategoriesImgMobile': isMobile}" alt="">
                                <div class="brand_name" [ngClass]="{'cat_nameMobile': isMobile}">{{brand.name}}</div>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    <div class="bokeh-background" *ngIf="magicPopup">
      <div class="popup-card animate-popup">
        <button class="close-btn" (click)="close()">×</button>

        <h2>Autoverse</h2>
        <p>Ready for some magic? ✨</p>

        <button class="magic-btn animate-cta" (click)="loadInstantDetails()">
          ✨ Get Magic Quote ✨
        </button>

        <p class="sub-text">Experience the most magical car quote system ever created</p>
      </div>
    </div>


    <!-- </div> -->
     <!-- =meghana INSURANCE SIDEBAR -->
  <div class="overlay" [class.visible]="isInsurance" (click)="goBackList()" *ngIf="isInsurance && !isMobile"></div>
  <div class="sidebar-container" *ngIf="isInsurance">
    <div class="create-req">
      <div *ngIf="!openEdit"><i (click)="goBackList()" >arrow_back</i>
        Create Request
      </div>
      <div *ngIf="openEdit"><i (click)="goBackList()" >arrow_back</i>
        Update Request Type
      </div>
      <div class="info" (click)="showPopup()">
        ?
      </div>
    </div>
    
    <div class="overflow">
    <h3 class="choose">Choose Request Type</h3>

    <div class="options">
      <div class="card" [ngClass]="{active: selectedType === 'insurance'}"
          (click)="selectType('insurance')">
        <div class="icon">🛡️</div>
        <div>
          <h4>Insurance</h4>
          <p>For insurance claims with insurer billing</p>
        </div>
      </div>

      <div class="card" [ngClass]="{active: selectedType === 'non-insurance'}"
          (click)="selectType('non-insurance')">
        <div class="icon">🧾</div>
        <div>
          <h4>Non-Insurance</h4>
          <p>For retail/regular jobs</p>
        </div>
      </div>
    </div>

    <div class="insurance-section" *ngIf="selectedType === 'insurance' && insurance.length>1">
    <h4 class="subtitle">Select Insurance Company</h4>
    <input
      type="text"
      class="search-box"
      placeholder="Search insurer (e.g., ICICI, HDFC)"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchChange()"
    />

    <div class="company-grid">
      <div
        class="company-card"
        *ngFor="let company of filteredList"
        (click)="selectCompany(company)"
        [ngClass]="{ selected: selectedCompany === company.insuranceGarageKey }"
      >
        <!-- <div class="circle"></div> -->
        <p>{{ company.insuranceGarageName }}</p>
      </div>
    </div>
  </div>

  </div>

  <div class="error-div">
        <p class="error" *ngIf="showError">
      Please choose Insurance or Non-Insurance.
    </p>     
    <p class="error" *ngIf="showError1">
      Please select an insurance company.
    </p>
    <div class="actions" *ngIf="openEdit">
      <button class="primary-btn"
          [class.active]="isContinueActive"
          (click)="updateInsurance()" style="width: 97%;">
        Update
      </button>

    </div>
    <div class="actions" *ngIf="!openEdit">
      <button class="secondary-btn" (click)="skip()">Skip & decide later</button>
      <button class="primary-btn"
          [class.active]="isContinueActive"
          (click)="continue()">
        Continue
      </button>

    </div>
    </div>
  </div>
<!-- =meghana INSURANCE SIDEBAR END? -->
    </div>

  </div>

<div class="popup-overlay" *ngIf="showPopupinfo">
  <div class="popup-box">
    <h3>Which option to choose?</h3>
    <p>
      <strong>Insurance:</strong><br>
      If work is under insurance claim. We'll bill the insurer.
    </p>
    <p>
      <strong>Non-Insurance:</strong><br>
      For regular/retail jobs. We'll bill the garage.
    </p>
    <button (click)="closePopup()">Got it</button>
  </div>
</div>
    <!-- =============cart shared popup======= -->
<!-- <div class="popup-overlay" *ngIf="showSharedWtemPopup">
  <div class="popup-container">
    <div class="close-h3">
        <mat-icon class="close-icon" (click)="closeSharedWtemPopup()">close</mat-icon>
        <h3 class="popup-title">Cart items shared with you!</h3>
    </div>
    <div class="popup-content">
  <div class="item-card" *ngFor="let item of cartItems">
    <div class="offer-tag" *ngIf="item.discount > 0 && item.mrp > 0">
      {{ ((item.discount / item.mrp) * 100).toFixed(0) }}% off
    </div>

    <img [src]="item.imageUrl || 'assets/images/logos/logo.png'" class="item-image" alt="item image" />

    <div class="item-info">
      <div class="item-title">{{ item.name }}</div>
      <div class="item-units">{{ item.cartQty || 1 }} Units</div>
        <div class="item-brand" *ngIf="item.brandName">{{ item.brandName }}</div>
      <div class="item-part">{{ item.partNumber }}</div>

      <div class="item-price" *ngIf="item.discount > 0; else noDiscount">
        <span class="selling-price">₹{{ item.sellingPrice | number:'1.2-2' }}</span>
        <span class="mrp-price">₹{{ item.mrp | number:'1.2-2' }}</span>
        <div class="discount-price">You save ₹{{ item.discount | number:'1.2-2' }}</div>
      </div>

      <ng-template #noDiscount>
        <div class="item-price">
          ₹{{ item.mrp | number:'1.2-2' }}
        </div>
      </ng-template>

    </div>
  </div>
</div>

       <div class="popup-actions">
      <button class="add-to-cart-btn" (click)="addSharedCartToLocalCart()">Add To Cart</button>
      <button class="cancel-btn" (click)="closeSharedWtemPopup()">Cancel</button>
    </div>
   
  </div>
</div> -->

<app-asp-share-cart
  *ngIf="showSharedWtemPopup"
  [cartItems]="cartItems"
  [sharedCartKey]="sharedCartKey"
  (close)="showSharedWtemPopup = false">
</app-asp-share-cart>




<div #dynamicContainer></div>
<div #garageSelected></div>
<div #toolbarRef></div>
<div #intstantorder></div>
